import axios from 'axios';
import getApiBaseUrl from '../GetServer';

export const NewRole = async (NameRole: string) => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/new-role`;
    const token = localStorage.getItem('token');

    if (!token) {
      throw new Error('Token no disponible');
    }

    console.log("Creando nuevo rol:", NameRole);

    const response = await axios.post(
      endpoint,
      { 
        Rol: NameRole 
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (response.status !== 200) {
      throw new Error(response.data.message || 'Error al crear el rol');
    }

    if (!response.data || response.data.status !== 200) {
      throw new Error(response.data?.message || 'Respuesta inesperada del servidor');
    }

    return response.data;
  } catch (error: any) {
    let errorMessage = 'Error al crear el rol';
    
    if (error.response) {
      if (error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = `Error ${error.response.status}: ${error.response.statusText}`;
      }
    } else if (error.request) {
      errorMessage = 'No se recibió respuesta del servidor';
    }
    
    console.error('Error en NewRole:', errorMessage, error);
    throw new Error(errorMessage);
  }
};